import { Navigate } from 'react-router-dom';
import { PATH_PAGE } from './paths';
import {
  MainLayout,
  CompactLayout,
  Page404,
  HomePage,
  FaqsPage,
  TutorialsPage,
  AboutPage,
  TermsPage,
  PrivacyPage,
  Contact,
} from './elements';

export const publicRoutes = [
  {
    element: <MainLayout />,
    children: [
      { element: <HomePage />, index: true },
      { path: 'about-us', element: <AboutPage /> },
      { path: 'contact-us', element: <Contact /> },
      { path: 'faqs', element: <FaqsPage /> },
      { path: PATH_PAGE.tutorials, element: <TutorialsPage /> },
      { path: 'terms-conditions', element: <TermsPage /> },
      { path: 'privacy-policy', element: <PrivacyPage /> },
    ],
  },
  {
    element: <CompactLayout />,
    children: [{ path: '404', element: <Page404 /> }],
  },
  { path: '*', element: <Navigate to="/404" replace /> },
];